import React  from 'react';

import logoGpk from './../../img/garbagepailkids.png';

const LogoGpk = () => {
  return (
    <div className="brand">
      <img src={logoGpk} alt="" className="brand-logo" />
    </div>
  )
}

export default LogoGpk;